/* istanbul ignore file: this file does not contain any logic, only factory calls */ import { BaseOptions } from "@devowl-wp/utils";
const getStaticOptions = ()=>window[BaseOptions.getPureSlug(process.env.slug, true)].others;
export { getStaticOptions };
export * from "./request";
export * from "./i18n";
